<script setup>
import { watch } from "vue";
import "swiper/css";
import "swiper/css/bundle";
import Swiper, { Pagination, Navigation, Autoplay } from "swiper";
Swiper.use([Pagination, Navigation, Autoplay]);

const props = defineProps({
  banners: {
    type: Array,
    default: () => [],
  },
});

watch(
  () => props.banners,
  (val) => {
    if (val) initSlider();
  }
);

const initSlider = () => {
  setTimeout(() => {
    const slider = new Swiper("#bannerSlider", {
      autoplay: { delay: "5000" },
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }, 150);
};

const rightBanner = (bannerObj) => {
  return window.innerWidth > 721 ? bannerObj.image : bannerObj.imageMobile;
};
</script>
<template>
  <div class="container">
    <div
      v-show="!loading && props.banners.length > 0"
      id="bannerSlider"
      class="swiper"
    >
      <div class="swiper-wrapper">
        <div
          v-for="banner in props.banners"
          :key="banner.id"
          class="swiper-slide"
        >
          <picture>
            <source
              media="(max-width:720px)"
              :srcset="banner.imageMobile"
              alt="imagem banner"
            />
            <source
              media="(min-width:721px)"
              :srcset="banner.image"
              alt="imagem banner"
            />
            <img
              :src="rightBanner(banner)"
              alt="imagem banner"
              loading="lazy"
            />
          </picture>
        </div>
      </div>

      <div id="bannerPagination" class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  margin-top: 5rem;
  @media only screen and (max-width: 720px) {
    margin: 5rem 0 0 0;
    width: 100%;
  }
}

img {
  position: relative;
  width: 100%;
}

.swiper-button-next,
.swiper-button-prev {
  width: 40px !important;
  height: 40px !important;
  border-radius: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  &::after {
    color: #fff !important;
    font-size: 18px !important;
  }
}
</style>
